import { IconButton } from "@material-ui/core";
import styled from "styled-components";

const ActionIconButton = styled(IconButton)`
  padding: 0.5rem;
  & svg {
    display: block;
    width: 18px;
    height: 18px;
  }
`;

export default ActionIconButton;
